// 统一请求路径前缀在libs/axios.js中修改
import {
  postloginRequest,
  getRequest,
  putRequest,
  postDataRequest,
  postDataRequest2,
  postRequest,
  showmideaRequest22,
  deleteRequest,
  getDetails1,
  postDataRequestBase,
  formDatapostRequest,
  postDataRequestex,
  postRequest2,
  postRequestpdfORimg,
  postaddFeedback
} from '@/utils/axios';
import { postDataRequestexCode, postGeoserverplugin } from '@/utils/axiosPlus';
import Cookies from 'js-cookie';
import appConfig from 'appConfig';
// 统一请求路径前缀
let base = appConfig.base;
let baseShp = appConfig.baseXbootShp;
let baseMapserver = appConfig.baseMapServer;

// 反馈接口
export const addFeedback = (url, params) => {
  return postaddFeedback('/feedback/addFeedback', params);
};

// 登陆
export const loginurl = '/addons/yun_shop/api.php';
// 订单
// export const getOrderListurl = "/addons/yun_shop/api.php";
export const getOrderList = (url, params) => {
  return getRequest(url, params);
};
// 商品详情
export const getDetails = (url, params) => {
  return getDetails1(url, params);
};

// 登陆
export const login = (url, params) => {
  return postloginRequest(url, params);
};

export const logout =()=>{
  return postRequest('/user/logout');
}

// 登陆
export const pageoffice = params => {
  return postRequest('/act/word', params);
};
// 获取用户登录信息
export const userInfo = params => {
  return getRequest('/user/info', params);
};
// 注册
export const regist = (url, params) => {
  return postRequest(url, params);
};
// 初始化验证码
export const initCaptcha = (url, params) => {
  return getRequest(url, params);
};
// 发送短信验证码
export const sendSms = (mobile, params) => {
  return getRequest(`/common/captcha/sendSms/${mobile}`, params);
};
// 发送重置密码短信验证码
export const sendResetSms = params => {
  return postRequest('/common/captcha/sendResetSms', params);
};
// 通过手机重置密码
export const resetByMobile = params => {
  return postRequest('/user/resetByMobile', params);
};
// 发送重置密码邮件验证码
export const sendResetEmail = params => {
  return postRequest('/email/sendResetCode', params);
};
// 通过邮件重置密码
export const resetByEmail = params => {
  return postRequest('/email/resetByEmail', params);
};
// 短信验证码登录
export const smsLogin = params => {
  return postRequest('/user/smsLogin', params);
};
// IP天气信息
export const ipInfo = params => {
  return getRequest('/common/ip/info', params);
};
// 获取我的待办 已办 督办 挂起
export const getActiviti = params => {
  return getRequest('/activiti/getOneAct', params);
};
// 个人中心编辑
export const userInfoEdit = params => {
  return postRequest('/user/edit', params);
};
// 个人中心发送修改邮箱验证邮件
export const sendCodeEmail = (email, params) => {
  return getRequest(`/email/sendCode/${email}`, params);
};
// 个人中心发送修改邮箱验证邮件
export const editEmail = params => {
  return postRequest('/email/editEmail', params);
};
// 个人中心修改密码
export const changePass = params => {
  return postRequest('/user/modifyPass', params);
};
// 个人中心修改手机
export const changeMobile = params => {
  return postRequest('/user/changeMobile', params);
};
// 解锁
export const unlock = params => {
  return postRequest('/user/unlock', params);
};

// github登录
export const githubLogin = params => {
  return getRequest('/social/github/login', params);
};
// qq登录
export const qqLogin = params => {
  return getRequest('/social/base/login', params);
};
// 微博登录
export const weiboLogin = params => {
  return getRequest('/social/weibo/login', params);
};
// 绑定账号
export const relate = params => {
  return postRequest('/social/relate', params);
};
// 获取JWT
export const getJWT = params => {
  return getRequest('/social/getJWT', params);
};

// 订单
export const getDetail = params => {
  return getRequest('/order/order', params);
};

// base64上传
export const base64Upload = params => {
  return postRequest('/upload/file', params);
};

//字典

// 获取全部字典
export const getAllDictList = params => {
  return getRequest('/dict/getAll', params);
};
// 添加字典
export const addDict = params => {
  return postRequest('/dict/add', params);
};
// 编辑字典
export const editDict = params => {
  return postRequest('/dict/edit', params);
};
// 删除字典
export const deleteDict = (ids, params) => {
  return deleteRequest(`/dict/delByIds/${ids}`, params);
};
// 搜索字典
export const searchDict = params => {
  return getRequest('/dict/search', params);
};
// 获取全部字典数据
export const getAllDictDataList = params => {
  return getRequest('/dictData/getByCondition', params);
};
// 添加字典数据
export const addDictData = params => {
  return postRequest('/dictData/add', params);
};
// 编辑字典数据
export const editDictData = params => {
  return postRequest('/dictData/edit', params);
};
// 删除字典数据
export const deleteData = (ids, params) => {
  return deleteRequest(`/dictData/delByIds/${ids}`, params);
};
// 通过类型获取字典数据
export const getDictDataByType = (type, params) => {
  return getRequest(`/dictData/getByType/${type}`, params);
};

// 个人中心
//获取文件
export const getMyFile = (id, params) => {
  if (id) {
    return getRequest(`/myFile/getByCondition?folderId=${id}`, params);
  } else {
    return getRequest(`/myFile/getByCondition`, params);
  }
};
//获取文件
export const updataMyFile = params => {
  return putRequest('/myFile/updateFile', params);
};
// 批量删除
export const delAllFile = ids => {
  return deleteRequest(`/myFile/deleteFiles/${ids}`);
};
//分享文件
export const shareFile = params => {
  return putRequest('/myFile/shareFile', params);
};
//获取上传
export const uploadMyFile = params => {
  return postRequest('/myFile/uploadFile', params);
};

//回收站删除
export const delMyFile = (ids, params) => {
  return deleteRequest(`/myFile/delByIds/${ids}`, params);
};

// 个人中心
//获取数据
export const getMyData = (params, id) => {
  if (id === 0 || id) {
    return getRequest(`/myData/getByCondition?folderId=${id}`, params);
  } else {
    return getRequest('/myData/getByCondition', params);
  }
};
// 我的接受 /zituSpace/serviceShare/findResourceListShareMe    我接收的资源
export const findResourceListShareMe = (params, id) => {
  if (id === 0 || id) {
    return getRequest(`/serviceShare/findResourceListShareMe?folderId=${id}`, params);
  } else {
    return getRequest('/myData/getByCondition', params);
  }
};
//获取我的接收
// export const getMyData2 = params => {
//   return getRequest('/myData/getByCondition', params);
// };
//获取文件
export const deleteMyData = params => {
  return putRequest('/myData/updateData', params);
};
//取消分享/zituSpace/serviceShare/updateData
export const deleteServiceShare = params => {
  return putRequest('/serviceShare/updateData', params);
};
//分享文件
export const dataShare = params => {
  return putRequest('/myData/shareFile', params);
};
/*
 *@description:
 *@author: Fengxy
 *@date: 2023-03-21 08:41:26
 */
// 个人中心我的数据修改接口
export const shareToOther = params => {
  return postRequest('/serviceShare/insertServiceShare', params);
};
// 我的数据我的分享这个列表
export const myShared = params => {
  return getRequest('/serviceShare/findMyResourceList', params);
};
// 我的数据我接收的列表
export const myReceived = () => {
  return getRequest('/serviceShare/findResourceListShareMe');
};
//回收站删除
export const delMyData = (ids, params) => {
  return deleteRequest(`/myData/delByIds/${ids}`, params);
};
// 批量删除
export const delAllData = ids => {
  return deleteRequest(`/myData/deleteDatas/${ids}`);
};
//用户
export const getUserDepartment = params => {
  return getRequest('/user/getByCondition', params);
};
// 添加文件夹
export const addDir = params => {
  return postRequest('/folder/saveFolder', params);
};
// 获取文件夹
export const getDir = (status, type, params) => {
  if (type) {
    return getRequest(`/folder/findAll?status=${status}&type=${type}`, params);
  } else {
    return getRequest(`/folder/findAll?status=${status}`, params);
  }
};
// 删除文件夹
export const delDir = (id, params) => {
  return deleteRequest(`/folder/delByIds/${id}`, params);
};
// 上传文件
export const uploadDataFile = params => {
  return postRequest('/myData/upload', params);
};

//部门
// 获取一级部门
export const initDepartment = params => {
  return getRequest('/department/getByParentId/0', params);
};
// 加载部门子级数据
export const loadDepartment = (id, params) => {
  return getRequest(`/department/getByParentId/${id}`, params);
};
// 添加部门
export const addDepartment = params => {
  return postRequest('/department/add', params);
};
// 编辑部门
export const editDepartment = params => {
  return postRequest('/department/edit', params);
};
// 删除部门
export const deleteDepartment = (ids, params) => {
  return deleteRequest(`/department/delByIds/${ids}`, params);
};
// 搜索部门
export const searchDepartment = params => {
  return getRequest('/department/search', params);
};
// 通过部门获取全部用户数据
export const getUserByDepartmentId = (id, params) => {
  return getRequest(`/user/getByDepartmentId/${id}`, params);
};

// 获取查询的总条数
export const gettotalBylayername = (params, data) => {
  let url = params.urlL + '/query';
  let totalcount = 0;
  var data1 = JSON.parse(JSON.stringify(data));

  data1.where = data.where ? data.where : '1=1';
  data1.geometry = data.geometry ? data.geometry : '';
  data1.geometryType = data.geometryType ? data.geometryType : 'esriGeometryPolygon';
  var proj = appConfig.map.proj.split(':');
  data1.inSR = proj[1];
  data1.spatialRel = 'esriSpatialRelIntersects';
  data1.relationParam = '';
  data1.outFields = '*';
  data1.returnGeometry = true;
  data1.maxAllowableOffset = '';
  data1.geometryPrecision = '';
  data1.outSR = proj[1];
  data1.returnIdsOnly = false;
  data1.orderByFields = '';
  data1.returnZ = false;
  data1.returnM = false;
  data1.returnDistinctValues = false;
  data1.distance = data.distance;
  data1.units = 'esriSRUnit_Meter ';
  data1.returnGeometry = false;
  data1.returnCountOnly = true; //只返回个数

  // 删除存在分页的三个属性
  if (data1.resultOffset) delete data1.resultOffset;
  if (data1.resultRecordCount) delete data1.resultRecordCount;
  if (data1.supportsAdvancedQueries) delete data1.supportsAdvancedQueries;

  data1.f = 'pjson';
  $.ajax({
    type: 'post',
    url: url,
    async: false,
    dataType: 'json',
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    data: data1,
    success: function(resData) {
      //  返回geojsong格式
      totalcount = resData;
    },
  });

  return totalcount;
};

// 获取当前属性字段的类型
export const getAttributeBylayername = (params, data) => {
  let url = params.urlL + '/query';
  var data1 = JSON.parse(JSON.stringify(data));
  let totalFields = [];
  data1.returnGeometry = false;
  data1.returnCountOnly = false; //只返回个数

  // 删除存在分页的三个属性
  if (data1.resultOffset) delete data1.resultOffset;
  if (data1.resultRecordCount) delete data1.resultRecordCount;
  if (data1.supportsAdvancedQueries) delete data1.supportsAdvancedQueries;

  data1.f = 'pjson';

  $.ajax({
    type: 'post',
    url: url,
    async: false,
    dataType: 'json',
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    data: data1,
    success: function(resData) {
      //  返回geojsong格式
      // 判断返回
      if (resData && resData.fields && resData.fields.length > 0) {
        totalFields = resData.fields;
      }
    },
  });

  return totalFields;
};

//params 当前选中的图层信息
//data 当前属性查询条件批而未供等
export const shpSearch_espg = (url, data, tot) => {
  let that = this;
  var data1 = JSON.parse(JSON.stringify(data));
  let totalFeature = [];
  data1.returnGeometry = true;
  // // 删除存在分页的三个属性
  // data1.resultOffset = 0
  // data1.resultRecordCount = tot;
  data1.f = 'geojson';
  // 判断是否是featureserver
  // if (url.indexOf("FeatureServer") >= 0) {
  //   url = url.replace("FeatureServer", "MapServer")
  // }
  let dataparam = {
    layerName: url,
    paramMap: JSON.stringify(data1),
  };
  $.ajax({
    type: 'post',
    // url: baseShp + '/servicecad/exportShp',
    url: '/zituSpace/servicecad/exportShp',
    async: false,
    dataType: 'json',
    headers: {
      accessToken: Cookies.get('accessToken'),
    },
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    data: dataparam,
    success: function(resData) {
      //  返回geojsong格式
      totalFeature = resData;
    },
    error: function(e) {
      // that.$Message.info("导出失败")
      totalFeature = null;
    },
  });

  return totalFeature;
};
//params 当前选中的图层信息
//data 当前属性查询条件
export const shpSearch = (params, data, tot) => {
  let url = params.urlL;
  let that = this;
  var data1 = JSON.parse(JSON.stringify(data));
  let totalFeature = [];
  data1.returnGeometry = true;
  // if(data1.hasOwnProperty('wfs')) {
  //   delete data1.wfs
  // }
  // if(data1.hasOwnProperty('metaDataBase')) {
  //   delete data1.metaDataBase
  // }
  data1.f = 'geojson';
  let dataparam = {
    url: url,
    // layerName:data.urlL,
    paramMap: JSON.stringify(data1),
  };
  $.ajax({
    type: 'post',
    // url: baseShp + '/servicecad/exportShp',
    url: '/zituSpace/servicecad/exportShp',
    async: false,
    dataType: 'json',
    headers: {
      accessToken: Cookies.get('accessToken'),
    },
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    data: dataparam,
    success: function(resData) {
      //  返回geojsong格式
      totalFeature = resData;
    },
    error: function(e) {
      // that.$Message.info("导出失败")
      totalFeature = null;
    },
  });

  return totalFeature;
};

//导出excel和pdf数据
export const accessory = (params, data, tot, isPdf) => {
  let url = params.urlL + '/query';
  let that = this;
  var data1 = JSON.parse(JSON.stringify(data));
  let totalFeature = [];
  data1.returnGeometry = true;
  data1.f = 'pjson';
  let dataparam = {
    layerName: url,
    paramMap: JSON.stringify(data1),
    isPdf: isPdf ? isPdf : '',
  };

  // 导出zip
  return postDataRequest2(`/accessory`, dataparam);
};

// 底部属性全部结果查询
//params 当前选中的图层信息
//data 当前属性查询条件
export const propertySearch = (params, data, tot) => {
  let url = params.urlL + '/query';
  let that = this;
  var data1 = JSON.parse(JSON.stringify(data));
  let totalFeature = [];
  data1.returnGeometry = false;

  // 删除存在分页的三个属性
  data1.resultOffset = 0;
  data1.resultRecordCount = tot;
  data1.f = 'geojson';
  $.ajax({
    type: 'post',
    url: url,
    async: false,
    dataType: 'json',
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    data: data1,
    success: function(resData) {
      //  返回geojsong格式
      if (resData.features && resData.features.length > 0) {
        totalFeature = resData.features;
      } else {
        that.$Message.info('导出失败,结果为空');
      }
    },
    error: function(e) {
      that.$Message.info('导出失败');
    },
  });

  return totalFeature;
};

// 压盖分析请求
export const glandServer = params => {
  // 通过ajax请求/zituSpace/wps/intersection  走的wfs
  // /zituSpace/postGISSta/intersection  走数据库
  let that = this;
  var postUrl = '/zituSpace/postGISSta/intersection';
  var resdata = {};
  $.ajax({
    type: 'post',
    url: postUrl,
    async: false,
    contentType: 'application/json; charset=UTF-8',
    data: params,
    success: function(res) {
      if (res.code == 200 && res.success) {
        resdata = res.result;
      } else {
        that.$Message.info('查询失败');
      }
    },
    error: function(e) {
      that.$Message.info('查询失败');
    },
  });
  return resdata;
};
// http://192.168.1.25:8899/zituSpace/postGISSta/getFlowDirectionMatrix 流向分析的接口
export const flowServer = params => {
  return postRequest2(`/postGISSta/getFlowDirectionMatrix`, params);
};
// export const flowServer = params => {
//   // 通过ajax请求/zituSpace/wps/intersection  走的wfs
//   // /zituSpace/postGISSta/intersection  走数据库
//   let that = this;
//   var postUrl = '/zituSpace/postGISSta/getFlowDirectionMatrix';
//   var resdata = {};
//   $.ajax({
//     type: 'post',
//     url: postUrl,
//     contentType: 'application/json; charset=UTF-8',
//     data: params,
//     success: function(res) {
//       if (res.code == 200 && res.success) {
//         resdata = res.result;
//       } else {
//         that.$Message.info('查询失败');
//       }
//     },
//     error: function(e) {
//       that.$Message.info('查询失败');
//     },
//   });
//   return resdata;
// };
//图层压盖分析请求
export const geoServer = params => {
  // 通过ajax请求/zituSpace/wps/intersection
  let that = this;
  // var postUrl = '/zituSpace/wps/intersection';
  var postUrl = '/zituSpace/wps/overlapAnalysis';
  // var postUrl = '/geoserverplugin/wps/overlapAnalysis';
  // http://192.168.1.113:8899/geoserverplugin/wps/overlapAnalysis
  // http://192.168.1.27:9123/wps/overlapAnalysis
  var resdata = {};
  $.ajax({
    type: 'post',
    url: postUrl,
    async: false,
    contentType: 'application/json; charset=UTF-8',
    data: params,
    success: function(res) {
      if (res.code == 200 && res.success) {
        resdata = res.result;
      } else {
        that.$Message.info('查询失败');
      }
    },
    error: function(e) {
      that.$Message.info('查询失败');
    },
  });
  return resdata;
};
//图层压盖分析请求 add by  qqjuanqq 2023.02.21
export const geoServerNew = params => {
  // 通过ajax请求  http://192.168.1.25:8899/zituSpace/postGISSta/getComparativeAnalysisLayer
  let that = this;
  var postUrl = '/zituSpace/postGISSta/getComparativeAnalysisLayer';
  var resdata = {};
  $.ajax({
    type: 'post',
    url: postUrl,
    async: false,
    contentType: 'application/json; charset=UTF-8',
    data: params,
    success: function(res) {
      if (res.code == 200 && res.success) {
        resdata = res.result;
      } else {
        that.$Message.info('查询失败');
      }
    },
    error: function(e) {
      that.$Message.info('查询失败');
    },
  });
  return resdata;
};
// 查询分析之后的结果 http://192.168.1.25:8899/zituSpace/postGISSta/getComparativeAnalysisLayer
export const geoServerNewTwo = params => {
  return postRequest2('/postGISSta/getComparativeAnalysisLayer', params);
};
// 查询分析之后的结果 http://192.168.1.25:8899/zituSpace/postGISSta/getComparativeAnalysisList
export const getThreeList = params => {
  return postRequest2('/postGISSta/getComparativeAnalysisList', params);
};
// 根据改变分析的结果查询表格数据  http://192.168.1.25:8899/zituSpace/postGISSta/getChangeTrendList
export const getChangeData = params => {
  return postRequest2('/postGISSta/getChangeTrendList', params);
};
// 基本农田分析的擦除的接口  http://192.168.1.25:8899/zituSpace/postGISSta/getErasureIntersectionLayer
export const postFarmland = params => {
  return postRequest2('/postGISSta/getErasureIntersectionLayer', params);
};
// 查询的接口  http://192.168.1.25:8899/zituSpace/postGISSta/getErasureIntersectionLayerList
export const getFarmland = params => {
  return postRequest2('/postGISSta/getErasureIntersectionLayerList', params);
};
//图层压盖分析请求
// export const geoServerdatamap = (params) => {
//   // 通过ajax请求/zituSpace/wps/intersection
//   let that = this;
//   // var postUrl = '/zituSpace/wps/intersection';
//   var postUrl = '/geoserverplugin/wps/overlapAnalysis';
//   // http://192.168.1.113:8085/geoserver/tempzt/ows
//   var resdata = {};
//   $.ajax({
//     type: 'get',
//     url: postUrl,
//     async: false,
//     contentType: 'application/json; charset=UTF-8',
//     data: params,
//     success: function (res) {
//       if (res.code == 200 && res.success) {
//         resdata = res.result;
//       } else {
//         that.$Message.info('查询失败');
//       }
//     },
//     error: function (e) {
//       that.$Message.info('查询失败');
//     },
//   });
//   return resdata;
// };

// 供而未用分析
export const gewyAnalyServer = params => {
  // 通过ajax请求http://192.168.1.113:8888/geoserverplugin/wps/eraseAnalysis
  let that = this;
  var postUrl = '/wps/eraseAnalysis';
  return postDataRequestexCode(postUrl, params);
  // $.ajax({
  //   type: 'post',
  //   url: postUrl,
  //   // async: false,
  //   contentType: 'application/json; charset=UTF-8',
  //   data: params,
  //   success: function(res) {
  //     if (res.code == 200 && res.success) {
  //       resdata = res.result;
  //     } else {
  //       that.$Message.info('查询失败');
  //     }
  //   },
  //   error: function(e) {
  //     that.$Message.info('查询失败');
  //   },
  // });
  // return resdata;
};

// 未收储分析
export const gewyAnalyServerTwo = params => {
  // 通过ajax请求http://192.168.1.113:8888/geoserverplugin/wps/eraseAnalysis
  let that = this;
  var postUrl = '/wps/eraseAnalysis'; // ; '/postGISSta/stackAnalysis'
  return postGeoserverplugin(postUrl, params);
};

//获取数据服务
// 我的服务的左边的目录树
export const getDataService = () => {
  // return getRequest('/directory/getByParentId/0', params);
  return getRequest('/catalogSet/findListTreeWithMyData');
};
export const getMetaDataService = () => {
  return getRequest('/directory/getByParentId/0');
};
// 加载目录子级数据
export const loadDirectory = (id, params) => {
  return getRequest(`/directory/getByParentId/${id}`, params);
};
// 通过目录id获取arcgis服务列表
// /agsservicemanager/list
// 接口改了，换成和数管的一样了
export const getArcgisListByDirectoryId = params => {
  return getRequest(`/metaData/getMetaDataList`, params);
};
//启动　停止　删除服务 /zituSpace/agsservicemanager/stop
export const stopService = params => {
  return postRequest(`/agsservicemanager/stop`, params);
};

// 203-04-18-Fengxy-更改个人中心我的服务开启服务的接口
// /zituSpace/common/enableLayer 启用图层
export const startServiceInterface = params => {
  return postRequest('/common/enableLayer', params);
};
// /zituSpace/common/disableLayer 禁用图层
export const stopServiceInterface = params => {
  return postRequest('/common/disableLayer', params);
};

export const startService = params => {
  return postRequest(`/agsservicemanager/start`, params);
};
export const deleteService = params => {
  return postRequest(`/agsservicemanager/deleteGeoserver`, params);
};
// 更新分享状态的接口  /zituSpace/agsservicemanager/updateShareState   serviceName   serviceType  directoryId
export const getChangeState = params => {
  return postRequest(`/agsservicemanager/updateShareState`, params);
};
// 删除多媒体数据  /zituSpace/metaData/deleteByIds
export const deleteMeidaService = id => {
  return deleteRequest(`/metaData/deleteAll/${id}`);
};
// 获取属性结构的参数   /zituSpace/directory/getByParentId/0
export const getNodeTree = params => {
  return postRequest(`/directory/getByParentId/${params.parentId}`, params);
};
// 保存发布服务的接口
// /zituSpace/servicepublish/publishsdfile
export const saveData = params => {
  // return postRequest(`/servicepublish/publishsdfile`, params);
  return postRequest(`/uploader/publishShape`, params);
};

//获取二级数据服务
export const getDataServiceByParentId = (ids, params) => {
  if (ids) {
    return getRequest(`/metaData/findMetaDataByApplyCheck?directoryId=${ids}`, params);
  } else {
    return getRequest(`/metaData/findMetaDataByApplyCheck`, params);
  }
};

// 查看单条属性中媒体附件
export const showMideaData = params => {
  return showmideaRequest22('/media/getByCondition', params);
};

// 删除字典
export const deletemidea = params => {
  return postRequest(`/media/delPdf`, params);
};

// 删除批而未供等历史记录
export const deletehistory = params => {
  return postRequest(`/analysisAttribute/delById`, params);
};

// 获取一级数据
export const initLayerManage = params => {
  return getRequest('/layerTree/getTreeListByIds', params);
};
// 获取首页目录树的接口  GET http://localhost:8899/zituSpace/catalogSet/findTreeListNew
export const getTreeLayerNew = params => {
  return postRequest('/catalogSet/findTreeListNew', params);
};
// 获取首页 业务数据的目录树  GET http://localhost:8899/zituSpace/catalogSet/findTreeListFile
export const getTreeLayerNewRight = params => {
  return getRequest('/catalogSet/findTreeListFile', params);
};
export const downLoadFile = params => {
  return postRequestpdfORimg('/upload/downLoad', params);
};

//法律法规 分页获取数据
export const getRegulationsList = params => {
  return getRequest('/regulations/getByCondition', params);
};

//书签管理
export const saveBookmark = params => {
  return formDatapostRequest('/bookmark/save', params);
};

export const getBookmarkList = params => {
  return getRequest('/bookmark/getByCondition', params);
};

export const delBookmarkList = (ids, params) => {
  return deleteRequest(`/bookmark/delByIds/${ids}`, params);
};
// 空间准提分析
export const themeAnalysis = params => {
  // 通过ajax请求 /zituSpace/wps/intersectionAnalysis 2023.02.20之前
  // http://192.168.1.25:8899/zituSpace/postGISSta/intersectionAnalysis
  var postUrl = '/zituSpace/postGISSta/intersectionAnalysis';
  var that = this;
  var resdata = {};
  $.ajax({
    type: 'post',
    url: postUrl,
    async: false,
    dataType: 'json',
    contentType: 'application/json; charset=UTF-8',
    data: params,
    success: function(res) {
      if (res.code == 200) {
        resdata = res.data;
      }
    },
    error: function(e) {
      that.$Message.info('分析失败');
    },
  });
  return resdata;
};

export const fzxzAnalysis = (params, url) => {
  // 通过ajax请求
  var postUrl = baseMapserver + '/statisticAnalysis';
  if (url) {
    postUrl = url;
  }
  var resdata = {};
  $.ajax({
    type: 'post',
    url: postUrl,
    async: false,
    contentType: 'application/json',
    data: params,
    success: function(res) {
      if (res.code == 200) {
        resdata = res;
      }
    },
  });
  return resdata;
};

// dwg shp数据导入
export const shpUpload = params => {
  // 通过ajax请求
  var resdata = {};
  $.ajax({
    type: 'post',
    url: base + '/upload/addFeature',
    async: false,
    dataType: 'json',
    headers: {
      accessToken: Cookies.get('accessToken'),
    },
    //contentType: 'application/json',
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    data: params,
    success: function(res) {
      // console.log('发送了请求得到的结果', res);
      if (res.code == 200) {
        resdata = res;
      }
    },
  });
  return resdata;
};

// 导出word
export const exportWord = params => {
  return postDataRequestBase(`/export/exportWord`, params);
};
// 导出统计word
export const exportStatistics = params => {
  return postDataRequestBase(`/export/exportStatistics`, params);
};

// 删除我的图层

export const deleteMylayer = (ids, params) => {
  return deleteRequest(`/shpAddFeature/delById/${ids}`, params);
};

// 大屏统计四个表 qzy写的接口 POST http://localhost:8899/zituSpace/postGISSta/spaceTimeEvolution
export const queryStatistics = params => {
  return postDataRequestex(`/postGISSta/spaceTimeEvolution`, params);
};
// 大屏统计1个表 wx写的接口 /zituSpace/postGISSta/mapserver/analysisData
export const queryAnalysisData = params => {
  return postDataRequestex(`/postGISSta/mapserver/analysisData`, params);
};
export const exportTjWord = params => {
  return postDataRequest(`/statisticsWord`, params);
};
// 删除我的分享 DELETE http://localhost:8899/zituSpace/serviceShare/deleteShare
export const deleteMyjs = params => {
  return deleteRequest(`/serviceShare/deleteShare`, params);
};
//通用导出excel
export const exportTYExcel = params => {
  return postDataRequest(`/ygfx/intersectExport`, params);
};
export const exportTYExcelNew = params => {
  return postDataRequest(`/ygfx/intersectExportNewTwo`, params);
};

// 获取批而未供等历史数据
export const getHistoryData = params => {
  return getRequest(`/analysisAttribute/details`, params);
};

// 批而未供等word导出
export const AnalysisWord = params => {
  return postDataRequest2(`/uploadAnalysisWord`, params);
};

// 点击收藏
export const likeData = params => {
  return postRequest('/collect/addMetaData', params);
};

// 获取收藏
export const getLikeData = (id, params) => {
  return getRequest(`/collect/findMetaDataByCollect?directoryId=${id}`, params);
};

// 取消收藏
export const delLikeData = (id, params) => {
  return deleteRequest(`/collect/delByMetaData/${id}`, params);
};

// 获取详情
export const getLikeDetail = (id, params) => {
  return getRequest(`/metaData/detailsMetaData?id=${id}`, params);
};

// 申请
export const applyServe = params => {
  return postRequest('/applyCheck/addApplyCheck', params);
};

// 矿产权重叠分析
export const kcqcdfx = (params, url) => {
  // 通过ajax请求
  var postUrl = baseMapserver + '/universalAnalysisDjfx';
  if (url) {
    postUrl = url;
  }
  var resdata = {};
  $.ajax({
    type: 'post',
    url: postUrl,
    async: false,
    contentType: 'application/json',
    data: params,
    success: function(res) {
      if (res.code == 200) {
        resdata = res;
      }
    },
  });
  return resdata;
};

export const getAlllabel = params => {
  return getRequest('/serviceLabel/getAll', params);
};
// 我的数据
export const getMenu = params => {
  return getRequest('/dictData/getByType/myDataType?key=myDataType', params);
};

// 分享搜索用户
export const searchUserByName = (username, params) => {
  return getRequest('/user/searchByName/' + username, params);
};

// 获取服务元数据
export const getMetaData = id => {
  return getRequest(`/metaDataBase/selOne/${id}`);
};

// 编辑元数据
export const editMeta = params => {
  return postRequest('/metaDataBase/updateMetaDataBase', params);
};

// 获取图层目录的接口数据  localhost:8888/zituSpace/agsservicemanager/getServerLayers?serviceName=ceshi123&serviceType=mapServer&folder=/
export const getArcgisService = params => {
  return postRequest(`/agsservicemanager/getServerLayers`, params);
};

// 只能出图导出pdf和 png的接口  /xboot/smartPlot/exportSmartPic
export const getExportPDForPNG = params => {
  return postRequestpdfORimg('/smartPlot/exportSmartPic', params);
};
// 只能出图导出pdf和 png的接口  /xboot/smartPlot/base64GetImg  http://192.168.1.113:9005/xboot/smartPlot/previewSmartPic
export const getbase64GetImg = params => {
  return postRequest2('/smartPlot/previewSmartPic', params);
};
// 获取图层树字段数据
export const getTreeData = params => {
  return getRequest(`/wfs/getSelectDisplayColmsByLayerId`, params);
};

export const getpreviewMap = params => {
  return postRequest(`/agsservicemanager/preview`, params);
};
// // 获取应用
// export const getExternalLinks = params => {
//   return getRequest('/externalLinks/getByCondition', params);
// };

// 添加应用
export const postExternalLinks = params => {
  return getRequest('/externalLinks/addExternalLinks', params);
};
// 获取元数据
export const getmetaDataBaseList = params => {
  // return postRequest('/agsservicemanager/findArcgisDireTree', params);
  return postRequest('/dataManage/getByCondition', params);
};
// 获取列表  /findAllList
export const getExternalLinks = params => {
  return postRequest('/externalLinks/findAllList', params);
};
// 修改应用  /updateExternalLinks
export const updateExternalLinks = params => {
  return postRequest('/externalLinks/updateExternalLinks', params);
};
// 共享取消共享  /externalLinks/cancelSharing
export const updateShare = params => {
  return getRequest('/externalLinks/cancelSharing', params);
};
// 删除应用
export const delExternalLinks = ids => {
  return deleteRequest(`/externalLinks/delByIds/${ids}`);
};

// 获取arcgis服务的目录树 localhost:8888/zituSpace/agsservicemanager/findArcgisDireTree  post
export const getArcGisNode = params => {
  // return postRequest(`/agsservicemanager/findArcgisDireTree`, params)
  return postRequest(`/layer/getGeoserverWorkspaceList`, params);
};

// 分享我的图层
export const shareMylaryer = params => {
  return postRequest2('/shpAddFeature/share', params);
};
// 提交地块导入审核信息
export const postUpdateLand = params => {
  return postRequest(`/landUpdateAndCheck/updateLand`, params);
};

// 地块导入上传接口
export const postzipFileUrl = '/zituSpace/landUpdateAndCheck/resolveShpZipFile';

// 浏览量
export const postViewAndDownload = params => {
  return postRequest(`/externalLinks/addViewAndDownload`, params);
};

// 获取一级目录
export const appInitDirectory = params => {
  return getRequest('/applicationManager/getByParentId/0', params);
};
// /zituSpace/dictData/getByType/applicationType
export const appInitDirectoryss = params => {
  return getRequest('/dictData/getByType/applicationType', params);
};
// 加载目录子级数据
export const appLoadDirectory = (id, params) => {
  return getRequest(`/applicationManager/getByParentId/${id}`, params);
};

//样式管理 新增
// export const addStyle = params => {
//   return postRequest('/style/insertStyle', params);
// };
import axios from 'axios';

export const addStyle = params => {
  let accessToken = Cookies.get('accessToken');
  return axios.post('/zituSpace/style/insertStyle', params, {
    transformRequest: function(data, headers) {
      headers.accessToken = accessToken;
      delete headers.post['Content-Type'];
      return data;
    },
  });
};

///zituSpace/geoserverStyle/deleteByIds/{ids} 样式管理 删除
export const deleteStyleByIds = ids => {
  return deleteRequest(`/style/deleteStyle/${ids}`);
};

// /zituSpace/geoserverStyle/getByCondition   分页获取样式文件列表
export const getByCondition = params => {
  // return getRequest(`/geoserverStyle/getByCondition`, params);
  return getRequest(`/style/getMyStyle`, params);
};

// /zituSpace/layer/getStyleList   获取geoserver样式文件列表
export const getStyleList = params => {
  return getRequest(`/layer/getStyleList`, params);
};

// zituSpace/statisticAnalysisGeoserver 辅助选址分析结果-word导出
export const statisticAnalysisGeoserver = params => {
  return postRequest2(`/statisticAnalysisGeoserver`, params);
};
// http://localhost:8899/zituSpace/zoning/findListParent?value=620100
export const getAreaList = params => {
  return getRequest(`/zoning/findListParent`, params);
};
// 根据行政区编码 获取json  GET http://localhost:8899/xboot/adminCenter/findByAreaCode
export const getJSONByCode = params => {
  return getRequest(`/adminCenter/findByAreaCode`, params);
};
// 导出shp或text文件 http://192.168.1.29:8899/zituSpace/servicecad/exportShporTxt
export const postExportShpOrtext = params => {
  return postDataRequestBase(`/servicecad/exportShporTxt`, params);
};
// 获取行政行政区划的数据局GET http://localhost:8899/zituSpace/zoning/findListZoningAndChildren
export const getXZQHArea = params => {
  return getRequest(`/zoning/findListZoningAndChildren`, params);
};
// 获取目录树筛选的接口 GET http://localhost:8899/zituSpace/catalogSet/findListCatalogSetNodeOne
export const getScreenList = params => {
  return getRequest(`/catalogSet/findListCatalogSetNodeOne`, params);
};
// /zituSpace/geoserverStyle/getByCondition   分页获取样式文件列表
export const getByConditionStyle = params => {
  return getRequest(`/style/findStylePage`, params);
  // return getRequest(`/fileIcon/findFileIconPage`, params);
};
// 获取审核数据
export const getApplyData = params => {
  return getRequest('/applyCheck/getByCondition', params);
};
// 审核
export const apply = params => {
  return putRequest('/applyCheck/update', params);
};

// 删除应用
export const delApplys = ids => {
  return deleteRequest(`/applyCheck/delByIds/${ids}`);
};
// 预览pdf
export const previewFile = params => {
  return getRequest(`/upload/previewFile`, params);
};

// 我的服务新增目录时候要调用的接口
export const DirectoryUpdateTree = params => {
  return postRequest('/catalogSet/updateCatalogSet', params);
};
export const DirectoryinsertCatalogSet = params => {
  return postRequest('/catalogSet/insertCatalogSet', params);
};
export const DirectorydeleteCatalogData = params => {
  return deleteRequest('/catalogSet/deleteCatalogSet', params);
};
// 从数管中搬过来的接口
export const postInsetLayer = params => {
  return postRequest('/metaData/insert', params);
};
export const initDirectory = params => {
  return getRequest('/directory/getByParentId/0', params);
};
// 搜索
export const searchLayerManage = params => {
  return getRequest('/layerTree/search', params);
};
// 加载子级数据
export const loadLayerManage = (id, params) => {
  return getRequest('/layerTree/getByParentId/' + id, params);
};
// 专题图-土地潜力分析
export const getServerList = params => {
  return getRequest('/metaData/getMetaDataList', params);
};

// 首页左侧目录树，当前通过导入方式加载的图层和当前登录用户发布过的服务
export const getNewLayerTree = params => {
  return getRequest('/catalogSet/findListTreeWithOneMap', params);
};
// 缓冲退让分析的接口  POST http://localhost:8899/zituSpace/transformation/buffer
export const postTransformation = params => {
  return postRequest('/transformation/buffer', params);
};

// 获取图档管理数据 http://localhost:8899/zituSpace/archivesManage/findListFileBySys
export const findListFileBySys = params => {
  return getRequest('/archivesManage/findListFileBySys', params);
};
// POST http://localhost:8899/zituSpace/archivesManage/insertArchivesManage 新增图档管理
export const insertArchivesManage = params => {
  return postRequest('/archivesManage/insertArchivesManage', params);
};
// 投影转换下拉框模糊查询
export const selectLike = params => {
  return postRequest('/transformation/findAllEPSG', params);
};
// 通用分析 http://localhost:8899/zituSpace/postGISSta/universalOverlayLayer
export const universalOverlayLayer = params => {
  return postRequest('/postGISSta/universalOverlayLayer', params);
};
// 通用分析 http://localhost:8899/zituSpace/postGISSta/universalOverlayList
export const universalOverlayList = params => {
  return postRequest('/postGISSta/universalOverlayList', params);
};
// 业务数据获取目录树 GET /zituSpace/catalogSet/findTreeListDatabase
export const getBaseTree = params => {
  return getRequest('/catalogSet/findTreeListDatabase', params);
};
// 数据库获取列表的数据 /zituSpace/databaseDatas/getTableColumnsAndData
export const getTableList = params => {
  return postRequest('/databaseDatas/getTableColumnsAndData', params);
};
// genuine表明查询属性字段 /zituSpace/databaseDatas/getTableColumns
export const getFiledList = params => {
  return postRequest('/databaseDatas/getTableColumns', params);
};
// 查询值  POST http://localhost:8899/zituSpace/databaseDatas/getTableValue
export const getFiledListValue = params => {
  return postRequest('/databaseDatas/getTableValue', params);
};
// /zituSpace/postGISSta/getTableNameFields 两规差异获取字段
export const getTableNameFields = params => {
  return postRequest('/postGISSta/getTableNameFields', params);
};

// 2023-04-17-Fengxy-修改个人中心我的收藏的接口
export const getCollectedList = params => {
  return getRequest('/collect/findMetaDataByCollect', params);
};

// 个人中心我的服务检索目录
export const goSearchFolder = params => {
  return getRequest('/catalogSet/findListTreeWithMyData', params);
};

// 导出查询结果-Fengxy-230419
export const outPutSearchInfo = params => {
  return postRequestpdfORimg('/ygfx/intersectExportNew', params);
};
// 验证sql是否正确  http://localhost:8899/zituSpace/postGISSta/verifySQL
export const getCheckSql = params => {
  return postRequest('/postGISSta/verifySQL', params);
};
// 服务业务关联的返选  GET http://localhost:8899/zituSpace/layerAssFile/findListMetaData
export const findCatalogSetReverse = params => {
  return getRequest('/layerAssFile/findListMetaData', params);
};
// 预览GET http://localhost:8899/zituSpace/layerAssFile/findAllAssList
export const findAllAssList = params => {
  return getRequest('/layerAssFile/findAllAssList', params);
};
// 行政区划数据 /zituSpace/zoning/findListZoningAndChildren
export const getBoroughs = params => {
  return getRequest('/zoning/findListZoningAndChildren', params);
};
export const getBoroughsAndCount = params => {
  return getRequest(`/zoning/findListZoningAndChildrenAndResourcecount`, params);
};
// 获取实景三维-资源全景的数据接口
export const getZyqjList = params => {
  return getRequest(`/realistic/findRealisticPage`, params);
};
// 获取实景三维-详情数据
export const getfindRealisticById = params => {
  return getRequest(`/realistic/findRealisticById`, params);
};
// 一张图获取数据 http://localhost:4523/zituSpace/actBusiness/onemapPassList
export const getAllMapPoint = params => {
  return postRequest(`/actBusiness/onemapPassList`, params);
};
// /zituSpace/actBusiness/getOneMapPoint
export const getOneMapPoint = params => {
  return postRequest(`/actBusiness/getOneMapPoint`, params);
};
// 获取实景三维-浏览量
export const getSjswView = params => {
  return postRequest(`/realistic/swvisits`, params);
};
// OA编辑表单数据获取表单数据的接口
export const editTourFormOA = id => {
  return getRequest(`/tourismInfo/findTourismInfoById`, id);
};
// OA编辑表单数据获取表单数据的接口
export const userinfo = id => {
  return getRequest(`/sso/myinfo`, id);
};
// 注册接口
export const registUser = params => {
  return postRequest(`/user/registUserWithPC`, params);
};

// 找回密码-发送邮箱
export const sendCode = params => {
  return getRequest(`/sendMail/sendCode`, params);
};
// 找回密码-验证码校验
export const checkCode = params => {
  return getRequest(`/sendMail/checkCode`, params);
};
// 找回密码-修改密码
export const changePwd = params => {
  return getRequest(`/sendMail/changePwd`, params);
};

// 提取模块获取数据 http://localhost:4523/zituSpace/actBusiness/onemapPassList
export const onemapDataExtraction = params => {
  return postRequest(`/tourismInfo/onemapDataExtraction`, params);
};

// /zituSpace/actBusiness/onemapPassById
export const findTourismInfoById = params => {
  return getRequest(`/actBusiness/onemapPassById`, params);
};

// /zituSpace/home/visitsPlusOne
export const visitsPlusOne = params => {
  return getRequest(`/home/visitsPlusOne`, params);
};



// WEBPACK FOOTER //
// ./src/api/index.js